import { TextField } from "@mui/material";
import { FC, useState } from "react";
import { ControllerFieldState, ControllerRenderProps } from "react-hook-form";

const TaskTitle: FC<{
  field: ControllerRenderProps<any, string>;
  fieldState: ControllerFieldState;
}> = ({ fieldState, field }) => {
  const [taskName, setTaskName] = useState(field.value);
  return (
    <>
      <p>Task Title</p>
      <TextField
        {...field}
        variant="outlined"
        fullWidth
        autoComplete="off"
        value={taskName}
        onChange={(e) => {
          setTaskName(e.target.value?.slice(0, 200));
          field.onChange(e.target.value?.slice(0, 200));
        }}
        error={!!fieldState.error}
        helperText={fieldState.error ? fieldState.error.message : null}
        sx={{
          "& .MuiInputBase-root": {
            height: "40px",
            borderRadius: "8px",
          },
          "& .MuiInputBase-input": {
            height: "40px",
            boxSizing: "border-box",
            padding: "0 14px",
          },
        }}
      />
      <p style={{ textAlign: "end" }}>{taskName?.length || 0} / 200 characters</p>
    </>
  );
};
export default TaskTitle;
